import 'angieslist-styles/dist/css/bootstrap.css';
import { getCookie, setCookie } from 'angieslist-app-platform/lib/common/utils/cookieUtils';
import { get } from 'lodash';
import React from 'react';
import { hot } from 'react-hot-loader';
import Helmet from 'react-helmet-async';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import appActions from './redux/appActions';
import './app.scss';

// This must be a 'class' and not a pure render method so that HMR will work
/* eslint react/prefer-stateless-function: 0 */
class App extends React.Component {
  componentDidMount() {
    const { dispatchUserId, dispatchUserType } = this.props;
    const isBrowser = typeof window !== 'undefined';
    const userId = isBrowser
      ? decodeURIComponent(getCookie('ajs_user_id'))
          .replace(/[^a-z0-9áéíóúñü.,_-]/gim, '')
          .trim()
      : '';
    dispatchUserId(userId);
    if (isBrowser) {
      let userType;
      const MEMBER_USER_TYPE = 'Member';
      const RETURNING_VISITOR_USER_TYPE = 'Visitor - Returning';
      const NEW_VISITOR_USER_TYPE = 'Visitor - New';
      const userTypeCookie = getCookie('al_visitor_type');
      // Expire in 68 years (longest possible)
      const userTypeCookieExpires = new Date(
        new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 68
      ).toGMTString();
      if (
        (!!userId && userId !== 'null' && userId !== 'undefined') ||
        userTypeCookie === MEMBER_USER_TYPE
      ) {
        userType = MEMBER_USER_TYPE;
        setCookie('al_visitor_type', MEMBER_USER_TYPE, userTypeCookieExpires);
      } else if (!!userTypeCookie && userTypeCookie !== 'null') {
        userType = RETURNING_VISITOR_USER_TYPE;
        setCookie('al_visitor_type', RETURNING_VISITOR_USER_TYPE, userTypeCookieExpires);
      } else {
        userType = NEW_VISITOR_USER_TYPE;
        setCookie('al_visitor_type', NEW_VISITOR_USER_TYPE, userTypeCookieExpires);
      }
      dispatchUserType(userType);
    }
  }

  componentDidUpdate(prevProps) {
    const alString = get(prevProps, 'visitorAppReducer.activityLocation', '');
    if (alString !== '') {
      window.activityLocation = alString.indexOf(':') > -1 ? alString : `Visitor : ${alString}`;
    }
  }

  render() {
    const { children, googleVerification } = this.props;
    const s3Url = 'https://media.angi.com/s3fs-public/';
    const googleTagManager =
      children.props.location.pathname === '/'
        ? "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NS2BVZV');"
        : "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MX98LP3');";
    const googleSiteVerificationName =
      googleVerification.googleSiteVerification === undefined ||
      googleVerification.googleSiteVerification === ''
        ? ''
        : 'google-site-verification';
    const drupalUrl = process.env.DRUPAL_UI_URL || 'https://www.angieslist.com';
    const blueFavicon = 'Angi-logo-Blue-favicon.ico';
    const [favicon32, favicon16, favicon] =
      children.props.location.pathname === '/'
        ? [blueFavicon, blueFavicon, blueFavicon]
        : ['favicon-32x32.png', 'favicon-16x16.png', 'favicon.ico'];

    return (
      <div>
        <Helmet
          htmlAttributes={{
            xmlns: 'http://www.w3.org/1999/xhtml',
            lang: 'en',
            'xml:lang': 'en',
            version: 'XHTML+RDFa 1.0',
            'xmlns:content': 'http://purl.org/rss/1.0/modules/content/',
            'xmlns:dc': 'http://purl.org/dc/terms/',
            'xmlns:foaf': 'http://xmlns.com/foaf/0.1/',
            'xmlns:og': 'http://ogp.me/ns#',
            'xmlns:rdfs': 'http://www.w3.org/2000/01/rdf-schema#',
            'xmlns:sioc': 'http://rdfs.org/sioc/ns#',
            'xmlns:sioct': 'http://rdfs.org/sioc/types#',
            'xmlns:skos': 'http://www.w3.org/2004/02/skos/core#',
            'xmlns:xsd:': 'http://www.w3.org/2001/XMLSchema#',
            'xmlns:schema': 'https://schema.org/',
            'xmlns:article': 'http://ogp.me/ns/article#',
            'xmlns:book': 'http://ogp.me/ns/book#',
            'xmlns:profile': 'http://ogp.me/ns/profile#',
            'xmlns:video': 'http://ogp.me/ns/video#',
          }}
          titleTemplate='%s | Angi'
          meta={[
            { charset: 'utf-8' },
            { 'http-equiv': 'CONTENT-LANGUAGE', content: 'en-US' },
            { 'http-equiv': 'x-ua-compatible', content: 'ie=edge,chrome=1' },
            { 'http-equiv': 'x-dns-prefetch-control', content: 'on' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=no' },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:site_name',
              content: 'Angi | See for FREE our 12 Million Verified Reviews',
            },
            {
              property: 'og:title',
              content: 'Angi | See for FREE our 12 Million Verified Reviews',
            },
            {
              property: 'og:image',
              content: `${drupalUrl}/sites/all/themes/altheme/images/angies-list-logo.png`,
            },
            {
              property: 'og:description',
              content:
                "Angi Ratings come from real people, not the Contractor's brother! Certified Data, real Reviews and businesses can't pay. See why Angi is better than free review sites.",
            },
            {
              name: 'description',
              content:
                "Angi Ratings come from real people, not the Contractor's brother! Certified Data, real Reviews and businesses can't pay. See why Angi is better than free review sites.",
            },
            {
              name: googleSiteVerificationName,
              content: googleVerification.googleSiteVerification,
            },
            { name: 'msapplication-TileColor', content: '#da532c' },
            { name: 'msapplication-config', content: `${s3Url}browserconfig.xml` },
          ]}
          link={[
            { rel: 'dns-prefetch preconnect', href: '//media.angi.com', crossorigin: 'anonymous' },
            {
              rel: 'dns-prefetch preconnect',
              href: '//google-analytics.com',
              crossorigin: 'anonymous',
            },
            {
              rel: 'dns-prefetch preconnect',
              href: '//ajax.googleapis.com',
              crossorigin: 'anonymous',
            },
            { rel: 'dns-prefetch preconnect', href: '//cdn.segment.com', crossorigin: 'anonymous' },
            { rel: 'dns-prefetch preconnect', href: '//api.segment.io', crossorigin: 'anonymous' },
            {
              rel: 'dns-prefetch preconnect',
              href: '//angieslist.tt.omtrdc.net',
              crossorigin: 'anonymous',
            },
            { rel: 'dns-prefetch preconnect', href: '//member.angi.com', crossorigin: 'anonymous' },
            { rel: 'apple-touch-icon', sizes: '180x180', href: `${s3Url}apple-touch-icon.png` },
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '32x32',
              href: `${s3Url + favicon32}`,
            },
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '16x16',
              href: `${s3Url + favicon16}`,
            },
            { rel: 'manifest', href: `${s3Url}site.webmanifest` },
            { rel: 'mask-icon', href: `${s3Url}safari-pinned-tab.svg`, color: '#5bbad5' },
            { rel: 'shortcut icon', type: 'image/png', href: `${s3Url + favicon}` },
          ]}
          script={[{ innerHTML: googleTagManager }]}
        />
        {children}
      </div>
    );
  }
}

const mapDispatchToProps = {
  dispatchUserId: appActions.detectMemberCookie,
  dispatchUserType: appActions.setUserType,
};

const mapStateToProps = (state) => ({
  visitorAppReducer: state.visitorAppReducer,
  googleVerification: state.googleVerification,
});

App.propTypes = {
  children: PropTypes.element.isRequired,
  dispatchUserId: PropTypes.func,
  dispatchUserType: PropTypes.func,
  googleVerification: PropTypes.object,
};

App.defaultProps = {
  dispatchUserId: () => {},
  dispatchUserType: () => {},
  googleVerification: {},
};

export default compose(hot(module), pure, connect(mapStateToProps, mapDispatchToProps))(App);



// WEBPACK FOOTER //
// ./src/app/browser/App.jsx